// @ts-nocheck

import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import { isDOOHCampaign } from 'sonata-static-storage/lib/helpers/campaign.helpers';

import { TooltipMenuStyle } from './CampaignStepsMenuStyled';

class CampaignStepsMenu extends React.Component {
  static propTypes = {
    campaignIds: PropTypes.array.isRequired,
    campaignNames: PropTypes.array,
    campaignTypes: PropTypes.array.isRequired,
    event: PropTypes.string,
    eventOff: PropTypes.string,
    globalEventOff: PropTypes.string,
    intl: PropTypes.object,
    place: PropTypes.string,
    theme: PropTypes.string,
    tooltipId: PropTypes.string.isRequired,
    type: PropTypes.string
  };

  static defaultProps = {
    theme: '1'
  };

  constructor(props) {
    super(props);
    const { campaignIds, campaignNames, campaignTypes } = this.props;
    this.state = { listItems: [] };
    if (campaignIds.length === 1) {
      this.state.listItems = this.getCampaignMenuItems(campaignIds[0], campaignTypes[0]);
    } else {
      const formattedListItems = [];
      campaignIds.forEach((campaignId, indexKey) => {
        formattedListItems.push(
          {
            auxClass: 'campaignName',
            link: null,
            text: campaignNames[indexKey]
          },
          ...this.getCampaignMenuItems(campaignId, campaignTypes[indexKey])
        );
      });
      this.state.listItems = formattedListItems;
    }
  }

  getCampaignMenuItems(campaignId, campaignType) {
    const { intl } = this.props;
    const wizardUrl = isDOOHCampaign(campaignType) ? taptap.config.wizardUrl : '#!/';
    return [
      {
        id: `${campaignId}-step-1`,
        link: `${wizardUrl}campaign/${campaignId}/step/1`,
        text: intl.formatMessage({ id: `campaignStepsMenu.locations` })
      },
      {
        id: `${campaignId}-step-2`,
        link: `${wizardUrl}campaign/${campaignId}/step/2`,
        text: intl.formatMessage({ id: `campaignStepsMenu.settingsAudience` })
      },
      {
        id: `${campaignId}-step-3`,
        link: `${wizardUrl}campaign/${campaignId}/step/3`,
        text: intl.formatMessage({ id: `campaignStepsMenu.adCreatives` })
      }
    ];
  }

  render() {
    const {
      theme,
      type = 'light',
      tooltipId,
      place,
      event = 'click',
      globalEventOff = 'click',
      eventOff = 'mouseleave'
    } = this.props;
    const { listItems } = this.state;
    return (
      <TooltipMenuStyle className="campaignStepsMenu">
        <ReactTooltip
          border
          className="tooltipMenu"
          clickable
          effect="solid"
          event={event}
          eventOff={eventOff}
          globalEventOff={globalEventOff}
          id={tooltipId}
          place={place}
          type={type}
        >
          <div className="tooltipMenu__itemsContainer">
            {listItems.map((item, i) => {
              return (
                <a className={`tooltipMenu__item color-${theme} ${item.auxClass || ''}`} href={item.link} key={i}>
                  {item.text}
                </a>
              );
            })}
          </div>
        </ReactTooltip>
      </TooltipMenuStyle>
    );
  }
}

export default injectIntl(CampaignStepsMenu);
